import Backbone from 'backbone'
import template from './choose-dataset-step.hbs'
import ObjectSelector from 'scoreboard/components/object-selector'
import * as datasetSelectorOptions from 'scoreboard/datasets/dataset-selector-options'

const ChooseDatasetStep = Backbone.View.extend({

	className: 'single-tree-selector',

	initialize (options = {}) {
		this.options = options
	},

	render () {
		let selector = new ObjectSelector(datasetSelectorOptions.forSelector())
		this.$el.empty().append(template())
		this.$('.panel').append(selector.el)
		selector.render()
		this.listenTo(selector, 'select', (dataset) => {
			this.model.set('dataset', dataset)
		})
		return this
	}

})

export default ChooseDatasetStep

ChooseDatasetStep.__filename__ = 'reports/wizard/dataset-report/choose-dataset-step.js'
